export const userEmails = [
  "armughan.ahmed@visionetsystems.com",
  "rwarren@nadel.com",
  "tara.diosdado@nadel.com",
  "apalacios@nadel.com",
  "scolton@nadel.com",
  "mwestphal@nadel.com",
  "Joey Gotelli",
  "apokorny@nadel.com",
  "Bailey.Doane@nadel.com",
  "Jade Claehout",
  "dspence@nadel.com",
  "apalacios@nadel.com",
  "tara.diosdado@nadel.com",
  "jgotelli@nadel.com",
  "jade.claerhout@nadel.com",
  "bhylen@nadel.com",
  "skliewer@nadel.com",
  "MDemartino@nadel.com",
  "astone@nadel.com",
  "portaltestsales@nadel.com",
];
